import axiosInstance from 'config/AxiosConfig';
import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import { 
  HomeShortcutCreateReq, 
  HomeShortcutItem, 
  HomeShortcutUpdateReq, 
  HomeShortcutUpdateSortReq 
} from '../../domain/payload/response/homeShortcut/HomeShortcutResp';

const HomeShortcutService = () => {
  const getHomeShortcutList = async (
    token: string,
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<BaseResponse<HomeShortcutItem[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/home-shortcut/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to fetch home shortcut list';
    }
  };

  const getHomeShortcutDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<HomeShortcutItem>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/home-shortcut/detail`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          id: id
        }
        
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to fetch home shortcut detail';
    }
  };

  const createHomeShortcut = async (
    token: string,
    request: HomeShortcutCreateReq
  ): Promise<BaseResponse<HomeShortcutItem>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/home-shortcut/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to create home shortcut';
    }
  };

  const updateHomeShortcut = async (
    token: string,
    request: HomeShortcutUpdateReq
  ): Promise<BaseResponse<HomeShortcutItem>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/home-shortcut/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to update home shortcut';
    }
  };

  const updateSort = async (
    token: string,
    request: HomeShortcutUpdateSortReq
  ): Promise<BaseResponse<null>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/home-shortcut/update-sort`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to update sort order';
    }
  };

  const uploadIcon = async (
    token: string,
    id: string,
    file: File
  ): Promise<BaseResponse<{ url: string }>> => {
    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('file', file);

      const response = await axiosInstance.post(`/v1/legacy/cms/home-shortcut/upload-icon`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to upload icon';
    }
  };

  return {
    getHomeShortcutList,
    getHomeShortcutDetail,
    createHomeShortcut,
    updateHomeShortcut,
    updateSort,
    uploadIcon,
  };
};

export default HomeShortcutService;